export default __webpack_public_path__ + "images/37d0c041e96a16e6b2dcae34409b1178.svg";